<cb-alert-banner
  [show]="showAlertBanner()"
  [alertType]="alertType()"
  (close)="hideAlert()"
  id="globalAlert"
  data-testid="policy-alert-banner">
  <div>
    <div data-testid="policy-alert-banner-message">
      {{ message() }}
    </div>
  </div>
</cb-alert-banner>
